import { render } from "./PanelClienteServiciosActivos.vue?vue&type=template&id=83b6fb46&scoped=true"
import script from "./PanelClienteServiciosActivos.vue?vue&type=script&lang=js"
export * from "./PanelClienteServiciosActivos.vue?vue&type=script&lang=js"

import "./PanelClienteServiciosActivos.vue?vue&type=style&index=0&id=83b6fb46&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83b6fb46"]])

export default __exports__